import React from 'react';

const Forbidden = () => (
  <div>
    <h1>403 - Prepovedano</h1>
    <p>Nimate dovoljenja za dostop do te strani.</p>
  </div>
);

export default Forbidden;
